module.exports = __webpack_public_path__ + "static/media/4.1d43a937.png";